import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { IMG_HERO } from "@/lib/images";

const FALLBACK =
  "Kiwibares.nz is a naturist website featuring tasteful, non-sexual nudity in natural settings. By continuing you confirm you are 18 or older and that viewing this content is lawful where you are.";

export default function AgeGate() {
  const { accept, geo } = useSite();
  const [text, setText] = useState(FALLBACK);

  useEffect(() => {
    api.get("/public/pages/age-notice").then(({ data }) => setText(data.body)).catch(() => {});
  }, []);

  const notice = geo?.notice;
  return (
    <div className="fixed inset-0 z-[70] bg-[#1a261f]/40 backdrop-blur-md flex items-center justify-center p-4" data-testid="age-notice-modal">
      <div className="rise bg-[#fcfbfa] w-full max-w-3xl grid md:grid-cols-5 overflow-hidden shadow-2xl border border-[#e2dcd4]">
        <div className="hidden md:block md:col-span-2 relative">
          <img src={IMG_HERO} alt="New Zealand lake and mountains" className="absolute inset-0 w-full h-full object-cover" />
        </div>
        <div className="md:col-span-3 p-8 sm:p-10">
          <img src="/logo-badge.png" alt="Kiwibares — Happiness is no tan lines" className="w-14 h-14 mb-5" data-testid="age-notice-logo" />
          <p className="eyebrow flex items-center gap-2"><ShieldCheck size={14} /> Content notice · 18+</p>
          <h2 className="mt-4 text-3xl sm:text-4xl text-[#1f402b] leading-tight">Before you enter</h2>
          <p className="mt-5 text-[#3c4a41] leading-relaxed" data-testid="age-notice-text">{text}</p>
          {notice && (
            <div className="mt-5 border-l-2 border-[#c5903b] pl-4 text-sm text-[#5a665e]" data-testid="age-notice-regional">
              <span className="font-mono-k text-[11px] uppercase tracking-widest text-[#c5903b]">
                {geo?.country_code ? `Your region · ${geo.country_code}` : "Regional notice"}
              </span>
              <p className="mt-1">{notice.message}</p>
            </div>
          )}
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button onClick={accept} data-testid="accept-age-notice-button"
              className="bg-[#1f402b] text-white px-7 py-3.5 text-sm tracking-wide hover:bg-[#2c5a3d] transition-colors duration-200">
              I am 18+ — enter
            </button>
            <a href="https://www.google.com" data-testid="leave-age-notice-button"
              className="border border-[#e2dcd4] px-7 py-3.5 text-sm text-center text-[#1a261f] hover:border-[#1f402b] transition-colors duration-200">
              Leave
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
